import { Star, Award, Users, Clock, Shield, ThumbsUp } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

const reasons = [
  { icon: Star, title: "Doświadczenie", description: "Ponad 500 występów dla największych firm w Polsce" },
  { icon: Award, title: "Profesjonalizm", description: "Zawodowi komicy z wieloletnim stażem scenicznym" },
  { icon: Users, title: "Dostosowanie", description: "Program dopasowany do charakteru i potrzeb Twojej firmy" },
  { icon: Clock, title: "Punktualność", description: "Zawsze na czas, zawsze przygotowani" },
  { icon: Shield, title: "Bezpieczeństwo", description: "Pełne ubezpieczenie i umowa gwarantująca profesjonalną realizację" },
  { icon: ThumbsUp, title: "Rekomendacje", description: "Setki pozytywnych opinii od zadowolonych klientów" },
];

export const WhyUs = () => {
  return (
    <section id="why-us" className="py-24 animated-gradient text-white">
      <div className="container">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent font-semibold text-sm uppercase tracking-widest">Zaufaj nam</span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-white">
              Dlaczego my?
            </h2>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, i) => {
            const Icon = reason.icon;
            return (
              <ScrollReveal key={reason.title} delay={i * 100}>
                <div className="group p-8 rounded-2xl glass card-hover hover:bg-white/15 h-full flex flex-col">
                  <Icon className="w-10 h-10 text-accent mb-5 group-hover:scale-110 transition-transform" />
                  <h3 className="text-xl font-montserrat font-bold mb-2">{reason.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{reason.description}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
